<template>
  <div class="_modals">
    <!-- ============== instant price modal =============== -->
    <b-modal
      id="_instantprice__datetab"
      ref="modalIP"
      centered
      hide-header
      hide-footer
      title=""
    >
      <div class="d-block text-center">
        <p>
          After this page you will not be able to edit your shipment's detail
          informations. Do you want to continue to booking page ?
        </p>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <b-button @click="modalpress(false)" class="_modals__button mr-2">
            No, I want to check it again !</b-button
          >
          <b-button @click="modalpress(true)" class="_modals__button ml-2"
            >Yes, Continue</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_confirmation"
      ref="modalPrevIP"
      centered
      hide-header
      hide-footer
      title=""
    >
      <div class="cancel__alert text-center">
        <img src="@/assets/image/icon/warning.svg" alt="" />
        <p class="pt-4">Are you sure you want to leave this page?</p>
      </div>
      <div class="row mt-4">
        <div class="col-md text-center">
          <b-button @click="modalpress()" class="_modals__button mr-2"
            >Stay</b-button
          >
          <router-link
            :to="
              $route.name === 'RequestShipment'
                ? { name: 'RequestShipment' }
                : { name: 'RequestShipmentContract' }
            "
          >
            <b-button @click="modalpress()" class="_modals__button ml-2"
              >Leave</b-button
            >
          </router-link>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_instantprice__form"
      ref="modalIPform"
      centered
      hide-footer
      title=""
    >
      <div>
        <h4>Terms of shipment</h4>
        <p style="text-align: justify">
          Items' description on your order must exactly be matching with the
          physical items and your documents e.g. commercial invoice, packing
          list, etc. If the actual weight is more than what you’ve declared on
          your order, Andalin will charge you for the difference, and vice
          versa. Andalin do NOT accept illegal items e.g. illegal drugs,
          narcotics, weapons, etc. You accept all legal consequences for
          whatever items you are to export/import and hold Andalin harmless
          against any legal claim whatsoever. The price may change from time to
          time due to wrong HS-Code, random check by Custom Officer, incomplete
          licenses or any other reasons that may only arise at a later day.
        </p>
      </div>
      <div class="mt-3">
        <h4>Cancelations</h4>
        <p style="text-align: justify">
          An order cannot be cancelled by a User when it is confirmed for
          processing by Freight Forwarder. If for some reasons, such order is
          cancelled by a User after getting a confirmation from Freight
          Forwarder for further process, a 25% penalty of freight cost may
          apply. A compensation will then be paid to such Freight Forwarder
          based on this penalty. A penalty will not apply if it’s caused by a
          Force Majeur.
        </p>
      </div>
      <div class="row mt-5">
        <div class="col-md text-center">
          <b-button @click="goBack()" class="_modals__button mr-4"
            >Disagree
          </b-button>
          <b-button @click="placeOrderIP()" class="_modals__button ml-4"
            >I Agree with The Terms
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_instantprice__form3"
      ref="modalIPform2"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      title=""
    >
      <div class="">
        <p class="text-center">
          Your order has been placed. Go to manage shipment to see your order.
        </p>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <router-link to="/manage-shipment">
            <b-button
              @click="dialogGoToPayment()"
              class="_modals__button mt-3"
              style="width: 180px;"
              >Go to Manage Shipment</b-button
            >
          </router-link>
        </div>
      </div>
    </b-modal>

    <b-modal id="_detailspromo" ref="modalDetailsPromo" centered hide-footer>
      <div v-if="promoDetails" active>
        <div
          class="d-flex flex-row _infoheader__content justify-content-center align-items-center"
        >
          <img
            class="__imgScope"
            src="@/assets/image/instantprice/AIR CARGO BOX.svg"
            alt=""
            v-if="promoDetails.scope === 'AIR CARGO'"
          />
          <img
            class="__imgScope"
            src="@/assets/image/instantprice/box air courier.svg"
            alt=""
            v-else-if="promoDetails.scope === 'AIR COURIER'"
          />
          <img
            class="__imgScope"
            src="@/assets/image/instantprice/box LCL@3x.png"
            alt=""
            v-else-if="promoDetails.scope === 'LCL'"
          />
          <img
            class="__imgScope"
            src="@/assets/image/instantprice/container-white.svg"
            alt=""
            v-else
          />
          <div class="__fromTo">
            <p class="__aircargo">{{ promoDetails.scope }}</p>
            <p class="__city">
              {{ promoDetails.origin }} to {{ promoDetails.destination }}
            </p>
            <p class="__via">{{ getOptionTp(promoDetails.type) }}</p>
            <p class="__periods">
              Valid Until: {{ getDate(promoDetails.valid_date) }}
            </p>
          </div>
        </div>
        <div class="col p-0 __infobody">
          <p class="__companyname"><b> </b></p>
          <!-- <p class="__title mb-1"><b>Shipping Line :</b> <br> Evergreen </p>
          <p class="__title mb-1"><b>Estimate Delivery :</b> <br> 4 - 10 Days</p>
          <p class="__title mb-1"><b>Promo Price :</b> <br> {{promoDetails.currency}} {{promoDetails.new_price}} {{ "/ " + promoDetails.oum}} </p> -->
          <!-- <p class="__title"><b>Promo Conditions :</b></p> -->
          <!-- <p class="__title"><b>Promo Conditions :</b></p>
          <div class="row m-0">
            <div class="__condition">
              <p>Container Type</p>
              <p v-if="FCL">Temperature</p>
              <p>Terms of Payment</p>
              <p>Volume</p>
              <p>Additional Option</p>
            </div>
            <div>
              <p>: -</p>
              <p>: Max. 5'C</p>
              <p>: 7 Days</p>
              <p>: Minimum 50 Kg</p>
              <p>: -</p>
            </div>
          </div> -->
          <p class="__title"><b>Promo Details :</b></p>
          <div class="row m-0">
            <div class="__condition">
              <!-- <p>Type</p>
              <p v-if="FCL">Temperature</p>
              <p>Scope</p> -->
              <p>Shipping Line</p>
              <p>Transit Time</p>
              <p>Product Type</p>
              <p>Min-Quantity</p>
              <p>Remarks</p>
            </div>
            <div>
              <!-- <p>: {{getOptionTp(promoDetails.type)}}</p> -->
              <!-- <p>: Max. 5'C</p> -->
              <!-- <p>: {{promoDetails.scope}}</p> -->
              <p>: {{ promoDetails.shipping_line }}</p>
              <p>: {{ promoDetails.transit_time }}</p>
              <p>: {{ promoDetails.product_type }}</p>
              <p>: {{ promoDetails.min_oum }} {{ promoDetails.oum }}</p>
              <p class="__promoNotes">: {{ promoDetails.message }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="text-center">
          <button class="__btnGIN __background_navy">Get it Now!</button>
        </div> -->
      </div>
    </b-modal>

    <b-modal
      id="_pricedetails"
      ref="modalPriceDetails"
      centered
      title="Price Details"
      hide-footer
    >
      <div class="col-md __invoice p-0 text-left">
        <div
          class="mb-4 __section"
          v-if="
            orderPrice.orderPriceFreight &&
              orderPrice.orderPriceFreight.length > 0
          "
        >
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{ this.mixinGetGroupPriceName('FRE') }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div class="col-md-3 px-2 text-left __descripttype">
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div class="col-md px-2 __amounttype">Amount*</div>
            <div class="col-md-4 px-2 __notetype">Note</div>
          </div>
          <div>
            <div
              class="__tableqty"
              v-for="(item, i) in orderPrice.orderPriceFreight"
              :key="i"
            >
              <div class="row p-0 text-center __quantity">
                <div class="col-md-3 px-2 text-left __descriptqty">
                  {{ item.descPriceFreight | capitalize }}
                </div>
                <div class="col-md-1 px-2 __qtyqty">{{ item.qty }}</div>
                <div class="col-md px-2 __uomqty">
                  {{ getUOM(item.priceUOM) }}
                </div>
                <div class="col-md px-2 __amountqty ">
                  {{
                    item.priceSum
                      | currency('', 0, { spaceBetweenAmountAndSymbol: true })
                  }}
                </div>
                <div class="col-md-4 px-2 __notetype">
                  {{ item.orderNoteDetailFreight || '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-4 __section"
          v-if="
            orderPrice.orderPriceOrigin &&
              orderPrice.orderPriceOrigin.length > 0
          "
        >
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{ mixinGetGroupPriceName('LCORIGIN') }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div class="col-md-3 px-2 text-left __descripttype">
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div class="col-md px-2 __amounttype">Amount*</div>
            <div class="col-md-4 px-2 __notetype">Note</div>
          </div>
          <div>
            <div
              class="__tableqty"
              v-for="(item, i) in orderPrice.orderPriceOrigin"
              :key="i"
            >
              <div class="row p-0 text-center __quantity">
                <div class="col-md-3 px-2 text-left __descriptqty">
                  {{ item.descPriceOrigin | capitalize }}
                </div>
                <div class="col-md-1 px-2 __qtyqty">{{ item.qty }}</div>
                <div class="col-md px-2 __uomqty">
                  {{ getUOM(item.priceUOM) }}
                </div>
                <div class="col-md px-2 __amountqty ">
                  {{
                    item.orderPriceOrigin
                      | currency('', 0, { spaceBetweenAmountAndSymbol: true })
                  }}
                </div>
                <div class="col-md-4 px-2 __notetype">
                  {{ item.orderNoteDetailLC || '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-4 __section"
          v-if="
            orderPrice.orderPriceDestination &&
              orderPrice.orderPriceDestination.length > 0
          "
        >
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{
                mixinGetGroupPriceName('LCDESTINATION')
              }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div class="col-md-3 px-2 text-left __descripttype">
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div class="col-md px-2 __amounttype">Amount*</div>
            <div class="col-md-4 px-2 __notetype">Note</div>
          </div>
          <div>
            <div
              class="__tableqty"
              v-for="(item, i) in orderPrice.orderPriceDestination"
              :key="i"
            >
              <div class="row p-0 text-center __quantity">
                <div class="col-md-3 px-2 text-left __descriptqty">
                  {{ item.descPriceDestination | capitalize }}
                </div>
                <div class="col-md-1 px-2 __qtyqty">{{ item.qty }}</div>
                <div class="col-md px-2 __uomqty">
                  {{ getUOM(item.priceUOM) }}
                </div>
                <div class="col-md px-2 __amountqty ">
                  {{
                    item.orderPriceDestination
                      | currency('', 0, { spaceBetweenAmountAndSymbol: true })
                  }}
                </div>
                <div class="col-md-4 px-2 __notetype">
                  {{ item.orderNoteDetailLC || '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4 p-0 justify-content-start __totalamount">
          <p class="col-9 p-0"><b>Service Charges Total Amount</b></p>
          <p class="col-3 p-0 text-center __total">
            <b
              >IDR
              {{
                orderPrice.orderPriceTotal
                  | currency('', 0, { spaceBetweenAmountAndSymbol: true })
              }}</b
            >
          </p>
        </div>
        <section><b>Remarks from Andalin</b></section>
        <ol class="__remarkslist">
          <li>Taxes will be applicable at the time of invoicing</li>
          <li>Rates are subject to local charges at both ends</li>
          <li>
            Rates are subject to GRI, Prepaid Charges/Surcharges at actuals if
            applicable at the time of shipment
          </li>
          <li>
            Rates are subject to overweight surcharges on weight restriction
            clauses as per shipping lines conditions
          </li>
          <li>
            Vessel routing &amp; transit may change subject to operation
            feasibility
          </li>
          <li>All charges are subject to GST</li>
          <li>
            Exchange rate is subject to change according to carrier rate on the
            day of vessel sailing
          </li>
        </ol>
        <section><b>Remarks from Vendor</b></section>
        <ul class="__remarkslist">
          <li>{{ orderPrice.orderNote || '-' }}</li>
        </ul>
        <div class="row m-0 edit_price">
          <p class="mb-4 edit_price--details">* Amount in IDR</p>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_helpsubmit"
      ref="modalHelpSubmit"
      centered
      hide-footer
      hide-header
      hide-header-close
    >
      <div class="text-center">
        <p>
          Your enquiry has been made. Please wait, we will contact you back
          shortly.
        </p>
        <button
          class="__btnclose __btnActive __background_navy"
          @click="modalpress(true)"
        >
          Close
        </button>
      </div>
    </b-modal>
    <!-- ============== instant price modal end =============== -->

    <!-- ============== RFQ modal =============== -->
    <b-modal
      id="_instantprice__form2"
      ref="modalRFQ"
      centered
      hide-footer
      no-close-on-backdrop
      hide-header-close
      title=""
    >
      <div class="text-center" v-if="createdRfqIsLoading">
        <b-spinner variant="secondary" label="Spinning" />
      </div>
      <div v-else-if="!createdRfqIsLoading && createdRfq">
        <p class="text-center">
          Your request has been placed. Go to request list > RFQ List to see
          your application.
        </p>
        <!-- <div class="row">
          <div class="col-md mt-3 text-center">
            <router-link to="/request-list/rfq">
              <b-button @click="dialogGoToRFQlist()" class="_modals__button">Go to RFQ List</b-button>
            </router-link>
          </div>
        </div> -->
      </div>
    </b-modal>

    <!-- ============== RFQ Contract Error modal =============== -->
    <b-modal
      id="modalErrorRFQContract"
      ref="modalErrorRFQContract"
      centered
      hide-footer
      title=""
    >
      <div class="col-md p-0 text-center">
        <div class="mb-2">Please Try Again</div>
        <div class="mb-3">{{ errorMessage | TitleCase }}</div>
        <button class="button__bluecorporite" @click="modalpress()">OK</button>
      </div>
    </b-modal>

    <!-- ============ McEasy Error on Create RFQ Land ========= -->
    <b-modal
      id="modalErrorMcEasyRFQLand"
      ref="modalErrorMcEasyRFQLand"
      centered
      hide-footer
      header-class="global__bc_blue p-3"
      body-class="px-4 pb-5"
    >
      <template #modal-header>
        <h6 class="text-white mx-auto my-0">
          Order Submission Error
        </h6>
      </template>
      <div class="d-flex flex-column pt-4 align-items-center">
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11" cy="11" r="11" fill="#C4232A" />
          <path
            d="M12.0852 12.92H10.4298L10.0838 6.2915H12.4312L12.0852 12.92ZM10.0566 15.2403C10.0566 14.8604 10.1584 14.5732 10.3619 14.3787C10.5655 14.1842 10.8617 14.0869 11.2507 14.0869C11.6261 14.0869 11.9156 14.1864 12.1191 14.3855C12.3272 14.5845 12.4312 14.8694 12.4312 15.2403C12.4312 15.5976 12.3272 15.8803 12.1191 16.0884C11.9111 16.2919 11.6216 16.3937 11.2507 16.3937C10.8708 16.3937 10.5768 16.2942 10.3687 16.0952C10.1607 15.8916 10.0566 15.6067 10.0566 15.2403Z"
            fill="white"
          />
        </svg>
        <p class="text-sm text-black-50 my-3">
          There was an issue with your order submission. Please try again.
        </p>
        <button
          class="button__bluecorporite mt-3"
          @click="modalpress()"
          style="min-width: 54px;"
        >
          OK
        </button>
      </div>
    </b-modal>

    <b-modal
      id="requestlist-cancel"
      ref="modalRequestCancel"
      centered
      @hidden="resetModalFormRequest"
      hide-header
      hide-footer
      title=""
    >
      <div class="text-center mb-3">
        <img src="@/assets/image/icon/warning.svg" alt="" />
        <p class="mt-2">Are you sure to cancel the {{ formRequest.type }} ?</p>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <button
            @click="modalpress()"
            class="button__redsmall py-1 mr-2"
            style="width: 100px;"
          >
            No, I don’t
          </button>
          <button
            @click="deleteListRequest()"
            class="button__bluesmall py-1 ml-2"
            style="width:100px"
          >
            Yes Please
          </button>
        </div>
      </div>
    </b-modal>

    <!-- ============== RFQ modal end =============== -->

    <!-- ============== contract modal =============== -->
    <b-modal
      class="_contract__modal"
      ref="modalContact"
      centered
      hide-footer
      no-close-on-backdrop
      hide-header-close
      title=""
    >
      <div
        class="text-center"
        v-if="createdContractIsLoading && !createdContract"
      >
        <b-spinner variant="secondary" label="Spinning" />
      </div>
      <div v-else>
        <p class="text-center">
          Your request has been placed. <br />
          Go to request list > contract list to see your application.
        </p>
        <div class="row">
          <div class="col-md text-center mt-3">
            <router-link
              :to="{ name: 'RequestList', params: { type: 'contract' } }"
            >
              <b-button @click="modalpress()" class="_modals__button"
                >Go to Request List</b-button
              >
            </router-link>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- ============== contract modal end =============== -->

    <!-- ============== settings modal =============== -->
    <b-modal
      class="_settings__modal"
      id="setting-upload-doc"
      ref="modalUpload"
      centered
      hide-footer
      no-close-on-backdrop
      @hidden="resetModalUploadDoc('SETTING')"
      title="Upload Document"
    >
      <!-- <div v-if="isUploadingSetting">
        Uploading File ...
      </div> -->
      <!-- <div v-else-if="errorUploadingSetting">
        Upload file failed ...
      </div> -->
      <div>
        <form
          @submit.prevent="handleUploadSettingDocs"
          class=""
          action=""
          method=""
        >
          <div class="">
            <b-form-group
              id="input-group-1"
              label="Document Type"
              label-for="input-1"
              class="_setting__select"
            >
              <div class="_customdropdown__input">
                <b-input-group>
                  <b-dropdown right>
                    <template slot="button-content">
                      <p>{{ settingTypeValue }}</p>
                      <!-- <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg"> -->
                    </template>
                    <b-dropdown-item
                      v-on:click="selectedOption(option.value, 'type')"
                      v-for="option in settingOptionType"
                      :key="option.id"
                    >
                      <span>{{ option.text }}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </div>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              class="_settings__input"
              label="Select Your Document"
              label-for="input-1"
            >
              <input
                type="file"
                required
                placeholder="Select Your Document"
                name="fileSettingDoc"
                accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg, jpg"
                id="fileSettingDoc"
                ref="fileSettingDoc"
                v-on:change="handleFileSettingUpload"
                @keyup="chkInputFileSetting"
              />
            </b-form-group>
            <p class="_settings__info">*Maximum 5 MB</p>
            <p class="_settings__info mt-2 mb-1 text-center">
              {{ upload_error }}
            </p>
          </div>
          <div class="row">
            <div class="col-md text-center">
              <b-button
                type="submit"
                class="button__bluecorporite"
                :disabled="!isActive"
              >
                <span v-if="!isUploading">
                  Upload File
                </span>
                <span v-else>
                  <b-spinner small variant="light" label="Spinning" />
                </span>
              </b-button>
              <!-- <b-button @click="dialogUploadFile()" class="_modals__button">Upload File</b-button> -->
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal
      class="_settings__modal"
      id="setting-invite"
      ref="modalinviteuser"
      centered
      hide-footer
      title="Invite New User"
    >
      <div class="">
        <p class="_settings__smalltext">
          Enter your teammates email address to collaborate
        </p>
        <b-form-group
          id="input-group-1"
          class="_settings__input"
          label="Email Address"
          label-for="input-1"
        >
          <b-form-input
            v-validate="'required|email'"
            v-model="formUserInivite.email"
            type="email"
            name="usersEmail"
            data-vv-as="email"
            placeholder="Enter User Email Address"
          ></b-form-input>
        </b-form-group>
        <div class="__errorMsg text-center">
          {{ errors.first('usersEmail') }}
        </div>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <b-button
            @click="checkUsersInvited(formUserInivite.email)"
            class="_modals__button"
          >
            <span v-if="!isLoadingInvited">Invite</span>
            <span v-else
              ><b-spinner small variant="light" label="Spinning"
            /></span>
          </b-button>
          <div class="__updateMsg mt-2" v-if="invite_status">
            <p>{{ this.invite_alert_msg }}</p>
          </div>
          <div class="__errorMsg mt-2" v-else>
            <p>{{ this.invite_alert_msg }}</p>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- ============== settings modal end =============== -->

    <!-- ============== manage shipement modal =============== -->
    <b-modal
      class="_manageshipement__modal"
      id="mgshipment-detail-add"
      ref="modaladdRequest"
      centered
      hide-footer
      title=""
    >
      <template slot="modal-title">
        <h5>Edit Request</h5>
        <p>
          Order Number: <br />
          <span>{{ formShipmentReq.orderNumber }}</span>
        </p>
      </template>
      <div class="row m-0">
        <b-form-group
          id="input-group-1"
          label="Type"
          label-for="input-1"
          class="_mg__select"
        >
          <div class="_customdropdown__input">
            <b-input-group>
              <b-dropdown right>
                <template slot="button-content">
                  <p>{{ mgshipementTypeValue }}</p>
                  <img
                    class="__imgArrow"
                    src="@/assets/image/instantprice/right-arrow.svg"
                  />
                </template>
                <b-dropdown-item
                  v-on:click="selectedOption(option.text, 'mg-type')"
                  v-for="option in mgshipementOptionType"
                  :key="option.id"
                >
                  <span>{{ option.text }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group>
          </div>
        </b-form-group>
        <div class="row m-0 _mg__celcius" v-if="addRequestStatus === false">
          <b-form-input
            id="input-1"
            type="text"
            required
            placeholder="0"
            class=""
            v-model="inputShipmentReq.value"
          ></b-form-input>
          <p>&#8451;</p>
        </div>
        <div class="_mg__carrier" v-if="addRequestStatus === true">
          <b-form-input
            id="input-1"
            type="text"
            required
            placeholder="Carrier/Shipping Line Name"
            class=""
            v-model="inputShipmentReq.value"
          ></b-form-input>
        </div>
      </div>
      <div class="">
        <b-form-group id="input-group-1" label="Notes" label-for="input-1">
          <b-form-textarea
            placeholder="Type Here"
            rows="4"
            max-rows="6"
            v-model="inputShipmentReq.note"
          ></b-form-textarea>
        </b-form-group>
        <b-button class="_global__button--corporite" @click="addRequest">
          + Add Request
        </b-button>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <b-button @click="dialogAddRequest()" class="_modals__button"
            >Submit</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_manageshipement__modal2"
      ref="modaluploadDoc"
      centered
      hide-footer
      no-close-on-backdrop
      @hidden="resetModalUploadDoc('SHIPMENT')"
      title=""
    >
      <template slot="modal-title">
        <h5>Upload Document</h5>
      </template>
      <!-- <div
        v-if="!isUploading && !isErrorUploading">
        <h3 class="text-center">File has been uploaded</h3>
      </div> -->
      <!-- <div
        v-if="!isUploaded && isErrorUploading">
        <h3 class="text-center">Upload file failed</h3>
      </div> -->
      <div>
        <form
          @submit.prevent="handleUploadDoc"
          class="__formSignin"
          action=""
          method=""
        >
          <b-form-group
            id="input-group-1"
            label="Select Your File"
            label-for="input-1"
          >
            <div class="input__attach">
              <b-form-file
                v-model="formDoc.fileDocument"
                v-validate="'required'"
                name="file document"
                accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg"
              >
              </b-form-file>
              <p class="uploadfile_text">*Maximum 5 MB</p>
            </div>
            <p v-if="errors.has('file document')" class="fontstyle__errormsg">
              {{ errors.first('file document') }}
            </p>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="File Category"
            label-for="input-1"
            class="_mg__select"
          >
            <div class="_customdropdown__input">
              <b-input-group>
                <b-dropdown right>
                  <template slot="button-content">
                    <p>{{ mgshipementCategoryValue }}</p>
                    <img
                      class="__imgArrow"
                      src="@/assets/image/instantprice/right-arrow.svg"
                    />
                  </template>
                  <b-dropdown-item
                    v-on:click="selectedOption(option.value, 'mg-category')"
                    v-for="option in mgshipementCategory"
                    :key="option.id"
                  >
                    <span>{{ option.text }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group>
              <p class="fontstyle__errormsg pl-0">
                {{ errorFileCategory }}
              </p>
            </div>
          </b-form-group>
          <b-form-group
            id="input-file-name"
            label="File Name"
            label-for="input-1"
          >
            <b-form-input
              placeholder="File Name"
              v-model="formDoc.documentDesc"
              @keyup="chkInputFile"
              v-validate="'required'"
              name="file name"
            ></b-form-input>
            <p v-if="errors.has('file name')" class="fontstyle__errormsg">
              {{ errors.first('file name') }}
            </p>
          </b-form-group>
          <p class="uploadfile_text mb-3">{{ upload_error }}</p>
          <div class="row">
            <div class="col-md text-center">
              <button type="submit" class="button__bluecorporite">
                <span v-if="!isUploading">
                  Upload File
                </span>
                <span v-else>
                  <b-spinner small variant="light" label="Spinning" />
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
    <!-- ============== manage shipement end =============== -->
    <b-modal
      class="_uploadpayment__modal"
      ref="modalPaymentProof"
      centered
      hide-footer
      title="Upload Proof of Payment"
    >
      <div class="__body">
        <div
          class="d-flex flex-row align-items-center justify-content-between __sect1"
        >
          <img class="__lamp" src="@/assets/image/icon/lamp.svg" alt="" />
          <p class="m-0">
            Uploading proof of payment can fasten your payment verification
            process
          </p>
        </div>
        <p>
          Make sure that the proof of payment (receipt) show these information:
        </p>
        <div class="row text-left">
          <ul>
            <li>Transfer Date</li>
            <p>E.g: 11/07/2019 , 11 July 2019</p>
            <li>Transfer Status</li>
            <p>E.g: Success, Paid</p>
          </ul>
          <ul>
            <li>Recipient Name</li>
            <p>E.g: PT. Eximku Logistik Indonesia</p>
            <li>Amount of Money Transfered</li>
            <p>E.g: Rp 1,000,234.00</p>
          </ul>
        </div>
        <div class="col __attachment text-center">
          <img src="@/assets/image/icon/attach.svg" alt="" />
          <div>
            <button class="__background_navy">Select</button>
          </div>
          <p>Or<br />Drag Your File to here</p>
          <p class="__format">
            <b>File Format:</b> .PNG, .JPEG, .JPG, Max 10 MB
          </p>
        </div>
        <div class="text-center">
          <button class="__background_navy __btnUpload">Upload File</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_passwordreset__modal"
      ref="modalPasswordReset"
      centered
      hide-footer
      hide-header-close
      no-close-on-backdrop
      title="Reset Password"
    >
      <div class="__body text-center">
        <p class="my-3">{{ this.messageResetPass.message }}</p>
        <button class="button__bluesmall" @click="modalpressResetPwd()">
          Ok
        </button>
      </div>
    </b-modal>

    <b-modal
      id="_forgotpassword__modal"
      ref="modalForgotPassword"
      centered
      hide-footer
      hide-header
      hide-header-close
    >
      <div class="text-center">
        <p>
          We have sent an email to reset your password. <br />
          Please check your email.
        </p>
        <router-link to="/signin">
          <button class="__btnActive_navy" @click="modalpress(true)">Ok</button>
        </router-link>
      </div>
    </b-modal>

    <b-modal
      id="_forgotpassword__modal"
      ref="modalCollabsSuccess"
      centered
      hide-footer
      hide-header-close
    >
      <div class="text-center">
        <p>{{ colabText }}</p>
        <button class="button__bluecorporite" @click="closeModalCollabsSuccess">
          Ok
        </button>
      </div>
    </b-modal>
    <!-- ============== request shipment =============== -->
    <b-modal
      id="requestlist-extend"
      ref="modalRequestExtend"
      centered
      hide-footer
      @hidden="resetModalFormRequest"
      title=""
    >
      <form @submit.prevent="handleExtendRequest">
        <div class="d-block text-center">
          <h1 class="mb-2">Resend Request for Quotation</h1>
          <p>{{ formRequest.type }} Number : {{ formRequest.number }}</p>
          <p class="my-2">Extend Expired Date Until:</p>
          <b-form-input
            id="requestExpired"
            type="date"
            required
            placeholder=""
            class=""
            v-model="formRequest.requestExpired"
            :min="today"
          ></b-form-input>
        </div>
        <div class="row">
          <div class="col-md text-center">
            <button type="submit" class="button__bluesmall py-1 mt-4 mb-3">
              <span v-if="isLoadingExtend || isLoadingExtendContract">
                <b-spinner class="spinner__small--white" label="Loading.." />
              </span>
              <span v-else>Resend</span>
            </button>
            <p class="fontstyle__errormsg" v-if="isErrorExtendContract">
              {{ isErrorExtendContract.data.message }}
            </p>
            <p class="fontstyle__errormsg" v-if="isErrorExtend">
              {{ isErrorExtend.data.message }}
            </p>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="_instantprice__form"
      ref="modalrequestform"
      centered
      hide-footer
      title=""
    >
      <div class="">
        <h4>Terms of shipment</h4>
        <p style="text-align: justify">
          Items’ description on your order must exactly be matching with the
          physical items and your documents e.g. commercial invoice, packing
          list, etc. If the actual weight is more than what you’ve declared on
          your order, Andalin will charge you for the difference, and vice
          versa. Andalin do NOT accept illegal items e.g. illegal drugs,
          narcotics, weapons, etc. You accept all legal consequences for
          whatever items you are to export/import and hold Andalin harmless
          against any legal claim whatsoever. The price may change from time to
          time due to wrong HS-Code, random check by Custom Officer, incomplete
          licenses or any other reasons that may only arise at a later day.
        </p>
      </div>
      <div class="mt-3">
        <h4>Cancelations</h4>
        <p style="text-align: justify">
          An order cannot be cancelled by a User when it is confirmed for
          processing by Freight Forwarder. If for some reasons, such order is
          cancelled by a User after getting a confirmation from Freight
          Forwarder for further process, a 25% penalty of freight cost may
          apply. A compensation will then be paid to such Freight Forwarder
          based on this penalty. A penalty will not apply if it’s caused by a
          Force Majeur.
        </p>
      </div>
      <b-button @click="placeOrder()" class="modals__button mt-4"
        >I Agree with The Terms
      </b-button>
    </b-modal>

    <b-modal
      id="_instantprice__form"
      ref="modalrequestcontractform"
      centered
      hide-footer
      title=""
    >
      <div class="">
        <h4>Terms of shipment</h4>
        <p style="text-align: justify">
          Items’ description on your order must exactly be matching with the
          physical items and your documents e.g. commercial invoice, packing
          list, etc. If the actual weight is more than what you’ve declared on
          your order, Andalin will charge you for the difference, and vice
          versa. Andalin do NOT accept illegal items e.g. illegal drugs,
          narcotics, weapons, etc. You accept all legal consequences for
          whatever items you are to export/import and hold Andalin harmless
          against any legal claim whatsoever. The price may change from time to
          time due to wrong HS-Code, random check by Custom Officer, incomplete
          licenses or any other reasons that may only arise at a later day.
        </p>
      </div>
      <div class="mt-3">
        <h4>Cancelations</h4>
        <p style="text-align: justify">
          An order cannot be cancelled by a User when it is confirmed for
          processing by Freight Forwarder. If for some reasons, such order is
          cancelled by a User after getting a confirmation from Freight
          Forwarder for further process, a 25% penalty of freight cost may
          apply. A compensation will then be paid to such Freight Forwarder
          based on this penalty. A penalty will not apply if it’s caused by a
          Force Majeur.
        </p>
      </div>
      <b-button @click="placeOrderContract()" class="modals__button mt-4"
        >I Agree with The Terms
      </b-button>
    </b-modal>

    <b-modal
      id="_instantprice__form2"
      ref="modalrequestform2"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title=""
    >
      <div class="">
        <p class="text-center" v-if="isLoadingBook">
          Please wait
        </p>
        <p class="text-center" v-else-if="!isErrorBook">
          Your order has been placed. Our admin is currently checking the
          availability of your chosen bid.
        </p>
        <div class="text-center" style="color: #C4232A" v-else>
          <p>Failed Book:</p>
          <p>{{ isErrorBook.data.message }}</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md text-center">
          <router-link
            v-if="!isErrorBook"
            :to="{
              name: 'RequestList',
              params: {
                type: `${this.shipmentType === 'rfq' ? 'rfq' : 'contract'}`
              }
            }"
          >
            <b-button @click="dialogRequest()" class="_modals__button pl-4 pr-4"
              >Ok</b-button
            >
          </router-link>
          <b-button
            v-else
            @click="dialogRequest()"
            class="_modals__button pl-4 pr-4"
            >Ok</b-button
          >
        </div>
      </div>
    </b-modal>

    <!-- ============== request shipment end =============== -->

    <!-- ATTACHMENT REQUEST -->
    <b-modal
      id="_uploadattachment__modal"
      ref="modalUploadAttachment"
      centered
      hide-footer
      @hidden="resetModalUploadDoc('REQUEST')"
      no-close-on-backdrop
      title="Upload Document"
    >
      <!-- <div
      v-if="!isUploading && !isErrorUploading">
      <h3 class="text-center">File has been uploaded</h3>
    </div> -->
      <div v-if="!isUploaded && isErrorUploading">
        <h3 class="text-center">Upload file failed</h3>
      </div>
      <div v-else>
        <form
          @submit.prevent="handleUploadDocReq"
          class="__formSignin"
          action=""
          method=""
        >
          <div class="__body px-3">
            <b-form-group
              id="input-group-1"
              label="Select Your File"
              label-for="input-1"
            >
              <div class="input__attach">
                <b-form-file
                  v-model="formReq.fileDocument"
                  v-validate="'required'"
                  name="file document"
                  accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg"
                >
                </b-form-file>
                <p class="fontstyle__errormsg pt-1">*Maximum 5 MB</p>
              </div>
              <p v-if="errors.has('file document')" class="fontstyle__errormsg">
                {{ errors.first('file document') }}
              </p>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="File Category"
              label-for="input-1"
              class="_mg__select"
            >
              <div class="_customdropdown__input">
                <b-input-group>
                  <b-dropdown right>
                    <template slot="button-content">
                      <p>{{ requestCategoryValue }}</p>
                      <img
                        class="__imgArrow"
                        src="@/assets/image/instantprice/right-arrow.svg"
                      />
                    </template>
                    <b-dropdown-item
                      v-on:click="selectedOption(option.text, 'req-category')"
                      v-for="option in requestCategory"
                      :key="option.id"
                    >
                      <span>{{ option.text }}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </div>
              <p class="fontstyle__errormsg pl-0">
                {{ errorFileCategory }}
              </p>
            </b-form-group>
            <div class="mb-2">
              <p class="__title">File Name</p>
              <b-input-group class="__input w-100">
                <b-form-input
                  type="text"
                  placeholder="File Name"
                  v-validate="'required'"
                  v-model="formReq.documentDesc"
                  name="file name"
                  @keyup="chkInputFileReq"
                />
              </b-input-group>
              <p v-if="errors.has('file name')" class="fontstyle__errormsg">
                {{ errors.first('file name') }}
              </p>
            </div>
            <div class="file_size_info text-center mb-2">
              {{ upload_error }}
            </div>
            <div class="my-4 text-center">
              <button type="submit" class="button__bluecorporite">
                <span v-if="!isUploading">
                  Upload File
                </span>
                <span v-else>
                  <b-spinner small variant="light" label="Spinning" />
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
    <!-- END ATTACHMENT REQUEST -->

    <!-- PRICE DETAIL MANAGE SHIPMENT -->
    <b-modal
      id="_pricedetails"
      ref="modalPriceDetailsShipment"
      centered
      title="Price Details"
      hide-footer
    >
      <div class="col __invoice p-0 text-left" v-if="isLoadingPrice">
        <p class="__companyname">
          Loading Price ...
        </p>
      </div>
      <div class="col __invoice p-0 text-left" v-else-if="isErrorPrice">
        <p class="__companyname">
          Error Fetch Price ...
        </p>
      </div>
      <div class="col __invoice p-0 text-left" v-else>
        <p class="__companyname"></p>
        <div class="mb-4 __section" v-if="groupFreight">
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{ this.mixinGetGroupPriceName('FRE') }}</b>
            </p>
          </div>
          <div class="row p-0 __type text-center">
            <div
              class="px-2 text-left __descripttype"
              :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
            >
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div
              class="col-md px-2 __unitpricetype"
              v-if="statusShipment !== 0"
            >
              Unit Price*
            </div>
            <div
              class="px-2 __amounttype"
              :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
            >
              Amount*
            </div>
            <div class="col-md-3 px-2 __notetype">Note</div>
          </div>
          <div
            class="__tableqty"
            v-for="(item, index) in priceList"
            v-bind:key="`${item.priceId}_${index}`"
          >
            <div
              class="row p-0 text-center __quantity"
              v-if="chooseGroupComponent(item.priceGroupCode) === 'FREIGHT'"
            >
              <div
                class="px-2 text-left __descriptqty"
                :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
              >
                {{ item.priceDesc }}
                {{
                  mixinGetFreightType(
                    item,
                    freightInfo.type,
                    freightInfo.weightEstimation
                  )
                }}
              </div>
              <div class="col-md-1 px-2 __qtyqty">
                {{ item.qty ? parseFloat(item.qty) : '' }}
              </div>
              <div class="col-md px-2 __uomqty">
                {{ getUOM(item.priceUOM) }}
              </div>
              <div
                class="col-md px-2 __unitpriceqty"
                v-if="statusShipment !== 0"
              >
                {{ item.unitPrice | Currency }}
              </div>
              <div
                class="px-2 __amountqty "
                :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
              >
                {{ item.bookPriceSum | Currency }}
              </div>
              <div class="col-md-3 px-2 __noteqty ">
                {{ !item.note ? '-' : item.note }}
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 __section" v-if="groupLC">
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{ this.mixinGetGroupPriceName('LC') }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div
              class="px-2 text-left __descripttype"
              :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
            >
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div
              class="col-md-2 px-2 __unitpricetype"
              v-if="statusShipment !== 0"
            >
              Unit Price*
            </div>
            <div
              class="px-2 __amounttype"
              :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
            >
              Amount*
            </div>
            <div class="col-md-3 px-2 __notetype">Note</div>
          </div>
          <div
            class="__tableqty"
            v-for="(item, index) in priceList"
            v-bind:key="`${item.priceId}_${index}`"
          >
            <div
              class="row p-0 text-center __quantity"
              v-if="chooseGroupComponent(item.priceGroupCode) === 'LC'"
            >
              <div
                class="px-2 text-left __descriptqty"
                :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
              >
                {{ item.priceDesc | capitalize }}
              </div>
              <div class="col-md-1 px-2 __qtyqty">
                {{ item.qty ? parseFloat(item.qty) : '' }}
              </div>
              <div class="col-md px-2 __uomqty">
                {{ getUOM(item.priceUOM) }}
              </div>
              <div
                class="col-md-2 px-2 px-2 __unitpriceqty"
                v-if="statusShipment !== 0"
              >
                {{ item.unitPrice | Currency }}
              </div>
              <div
                class="px-2 __amountqty"
                :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
              >
                {{ item.bookPriceSum | Currency }}
              </div>
              <div class="col-md-3 px-2 __noteqty ">{{ item.note }}</div>
            </div>
          </div>
        </div>
        <div class="mb-4 __section" v-if="typeShipment !== 0 && groupOthers">
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{ this.mixinGetGroupPriceName('OTHERS') }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div
              class="px-2 text-left __descripttype"
              :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
            >
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2  __uomtype">UOM</div>
            <div
              class="col-md-2 px-2 __unitpricetype"
              v-if="statusShipment !== 0"
            >
              Unit Price*
            </div>
            <div
              class="px-2 __amounttype"
              :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
            >
              Amount*
            </div>
            <div class="col-md-3 px-2 __notetype">Note</div>
          </div>
          <div
            class="__tableqty"
            v-for="(item, index) in priceList"
            v-bind:key="`${index}_${item.priceId}`"
          >
            <div
              class="row p-0 text-center __quantity"
              v-if="chooseGroupComponent(item.priceGroupCode) === 'OVERTIME'"
            >
              <div
                class="px-2 text-left __descriptqty"
                :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
              >
                {{ item.priceDesc | capitalize }}
              </div>
              <div class="col-md-1 px-2 __qtyqty">
                {{ item.qty ? parseFloat(item.qty) : '' }}
              </div>
              <div class="col-md px-2 __uomqty">
                {{ getUOM(item.priceUOM) }}
              </div>
              <div
                class="col-md-2 px-2 __unitpriceqty"
                v-if="statusShipment !== 0"
              >
                {{ item.unitPrice | Currency }}
              </div>
              <div
                class="px-2 __amountqty"
                :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
              >
                {{ item.bookPriceSum | Currency }}
              </div>
              <div class="col-md-3 px-2 __noteqty ">{{ item.note }}</div>
            </div>
          </div>
        </div>
        <div class="mb-4 __section" v-if="groupReim">
          <div class=" __titlesection align-items-center">
            <p class="text-left">
              <b class="__title">{{
                this.mixinGetGroupPriceName('REIMBURSEMENT')
              }}</b>
            </p>
          </div>
          <div class="row  p-0 __type text-center">
            <div
              class="px-2 text-left __descripttype"
              :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
            >
              Price Component
            </div>
            <div class="col-md-1 px-2 __qtytype">Quantity</div>
            <div class="col-md px-2 __uomtype">UOM</div>
            <div
              class="col-md-2 px-2 __unitpricetype"
              v-if="statusShipment !== 0"
            >
              Unit Price*
            </div>
            <div
              class="px-2 __amounttype"
              :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
            >
              Amount*
            </div>
            <div class="col-md-3 px-2 __notetype">Note</div>
          </div>
          <div
            class="__tableqty"
            v-for="(item, index) in priceList"
            v-bind:key="`${item.priceId}_${index}`"
          >
            <div
              class="row p-0 text-center __quantity"
              v-if="
                chooseGroupComponent(item.priceGroupCode) === 'REIMBURSEMENT'
              "
            >
              <div
                class="px-2 text-left __descriptqty"
                :class="statusShipment !== 0 ? 'col-md-3' : 'col-md-4'"
              >
                {{ item.priceDesc | capitalize }}
              </div>
              <div class="col-md-1 px-2 __qtyqty">
                {{ item.qty ? parseFloat(item.qty) : '' }}
              </div>
              <div class="col-md px-2 __uomqty">
                {{ getUOM(item.priceUOM) }}
              </div>
              <div
                class="col-md-2 px-2 px-2 __unitpriceqty"
                v-if="statusShipment !== 0"
              >
                {{ item.unitPrice | Currency }}
              </div>
              <div
                class="px-2 __amountqty"
                :class="statusShipment !== 0 ? 'col-md' : 'col-md-3'"
              >
                {{ item.bookPriceSum | Currency }}
              </div>
              <div class="col-md-3 px-2 __noteqty ">{{ item.note }}</div>
            </div>
          </div>
        </div>
        <div></div>
        <div class="row mb-4 p-0 justify-content-start __totalamount">
          <p class="col-9 p-0"><b>Service Charge Total Amount</b></p>
          <p class="col-3 p-0 text-center __total">
            <b>IDR {{ totalPriceShipment | Currency }}</b>
          </p>
        </div>
        <section><b>Remarks from Andalin</b></section>
        <ol class="__remarkslist">
          <li>Taxes will be applicable at the time of invoicing</li>
          <li>Rates are subject to local charges at both ends</li>
          <li>
            Rates are subject to GRI, Prepaid Charges/Surcharges at actuals if
            applicable at the time of shipment
          </li>
          <li>
            Rates are subject to overweight surcharges on weight restriction
            clauses as per shipping lines conditions
          </li>
          <li>
            Vessel routing &amp; transit may change subject to operation
            feasibility
          </li>
          <li>All charges are subject to GST</li>
          <li>
            Exchange rate is subject to change according to carrier rate on the
            day of vessel sailing
          </li>
        </ol>
        <section v-if="remarksVendor"><b>Remarks from Vendor</b></section>
        <ul class="__remarkslist" v-if="remarksVendor">
          <li>
            <div class="__preline">{{ remarksVendor }}</div>
          </li>
        </ul>
        <div
          class="row m-0 p-3 text-right edit_price"
          :class="
            isLoadingPrice ? 'justify-content-end' : 'justify-content-between'
          "
        >
          <div class="edit_price--details" v-if="!isLoadingPrice">
            * Amount in IDR
          </div>
          <button
            @click="downloadPrice()"
            :disabled="isLoadingDownloadPriceDetail"
            class="button__bluecorporite ml-3"
          >
            <img
              src="@/assets/image/icon/download-invoice.svg"
              alt=""
              class="pr-1"
              v-if="!isLoadingDownloadPriceDetail"
            />
            <b-spinner v-else small variant="secondary"></b-spinner>
            Download
          </button>
        </div>
      </div>
    </b-modal>
    <!-- END PRICE DETAIL MANAGE SHIPMENT -->

    <b-modal
      id="add-shipment-ongoing"
      ref="modalAddShipment"
      centered
      hide-footer
      title=""
    >
      <template slot="modal-title">
        <h5>Add Shipment - {{ getShipmentType(shipmentType) }}</h5>
      </template>
      <h6 v-if="contractItem" class="text-center mb-3">
        <b class="">Contract Number:</b> <br />
        {{ contractItem.contract_number }}
      </h6>
      <div class="mt-5" v-if="isLoadingBidList">
        <b-spinner small variant="secondary"></b-spinner>
      </div>
      <form @submit.prevent="AddShipment()" v-else>
        <div class="row m-0">
          <b-form-group label="Date of Shipment" class="col-md-3 p-1">
            <b-form-input
              type="date"
              :min="today >= start_duration ? today : start_duration"
              :max="end_duration"
              required
              v-model="datePickup"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Quantity"
            class="col-md-3 p-1"
            v-if="
              shipmentType === 'AIRCARGO' ||
                shipmentType === 'AIRCOURIER' ||
                shipmentType === 'SEALCL'
            "
          >
            <b-input-group :append="satuan">
              <b-form-input
                type="number"
                v-model="loadsAIR_LCL.qty"
                required
                placeholder="0"
                @focus="deleteErrorMsg()"
                @input="calcTotalShipment()"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">{{ error_addshipment }}</div>
          </b-form-group>

          <div
            v-if="
              shipmentType === 'AIRCARGO' ||
                shipmentType === 'AIRCOURIER' ||
                shipmentType === 'SEALCL'
            "
            class="col-md p-1"
          >
            <b-form-group label="Weight">
              <b-input-group append="kg">
                <b-form-input
                  type="number"
                  step=".01"
                  v-model="loadsAIR_LCL.weight"
                  required
                  placeholder="0"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
              </b-input-group>
              <div class="fontstyle__errormsg">{{ error_addshipment }}</div>
            </b-form-group>
          </div>

          <div
            v-if="
              shipmentType === 'AIRCARGO' ||
                shipmentType === 'AIRCOURIER' ||
                shipmentType === 'SEALCL'
            "
            class="col-md-4 p-1"
          >
            <b-form-group label="Dimension">
              <b-input-group append="cm">
                <b-form-input
                  type="number"
                  placeholder="L"
                  required
                  v-model="loadsAIR_LCL.size.length"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
                <b-form-input
                  type="number"
                  placeholder="W"
                  required
                  v-model="loadsAIR_LCL.size.width"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
                <b-form-input
                  type="number"
                  placeholder="H"
                  required
                  v-model="loadsAIR_LCL.size.height"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
              </b-input-group>
              <div class="fontstyle__errormsg">{{ error_addshipment }}</div>
            </b-form-group>
          </div>

          <div v-if="shipmentType.includes('FCL')" class="col-md-3 p-1">
            <b-form-group label="Quantity">
              <b-input-group append="Container">
                <b-form-input
                  type="number"
                  v-model="loadsFCL.qty"
                  required
                  class="text-center"
                  placeholder="0"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
              </b-input-group>
              <div class="fontstyle__errormsg">{{ error_addshipment }}</div>
            </b-form-group>
          </div>

          <div v-if="shipmentType.includes('FCL')" class="col-md-3 p-1">
            <b-form-group label="Weight Estimation">
              <b-input-group class="" append="kg">
                <b-form-input
                  type="number"
                  v-model="weightEstimation"
                  required
                  placeholder="0"
                  step=".01"
                  @focus="deleteErrorMsg()"
                  @input="calcTotalShipment()"
                />
              </b-input-group>
              <div class="fontstyle__errormsg">{{ error_addshipment }}</div>
            </b-form-group>
          </div>
        </div>

        <div class="row m-0">
          <div class="col-md-3 p-0 px-1">
            <div class="row m-0 justify-content-between">
              <p style="padding-bottom: 11px">PO Number</p>
              <p class="fontstyle__infotext--gray">*optional</p>
            </div>
            <b-form-input
              type="text"
              v-model="formAddShipment.po_number"
              class="w-100"
              placeholder="0"
              @focus="deleteErrorMsg()"
            />
          </div>

          <b-form-group label="Notes" class="col-md p-1">
            <b-form-input
              name="Type Here"
              type="text"
              required
              v-model="formAddShipment.shipper_notes"
            >
            </b-form-input>
            <div
              class="text-center pt-2"
              :class="isErrorBook ? 'fontstyle__errormsg' : ''"
            >
              {{ addshipment_msg }}
            </div>
          </b-form-group>
        </div>

        <div>
          Total Shipment {{ totalUnit }}
          {{ shipmentType.includes('FCL') ? 'Container' : satuan }} /
          {{ totalWeight }} Kg
          {{
            shipmentType.includes('FCL')
              ? ''
              : `/ ${totalVolume} ${
                  shipmentType === 'SEALCL' ? 'CBM' : 'Volumetric'
                }`
          }}
        </div>

        <div class="row m-0 justify-content-end">
          <button
            type="submit"
            class="button__bluesmall px-3 py-1"
            :disabled="isLoadingBook"
          >
            <span v-if="isLoadingBook">
              <b-spinner small variant="light" label="Spinning" />
            </span>
            <span v-else>Submit</span>
          </button>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="_cant_add_shipment"
      ref="modalCantAddShipment"
      centered
      hide-footer
      title=""
    >
      <template slot="modal-title">
        <h4 class="m-0">
          <b v-if="remainingDays === 0">End of Contract</b>
          <b v-else>Insufficient Contract Value</b>
        </h4>
      </template>
      <div class="text-center">
        <p v-if="remainingDays === 0">
          Sorry, your contract duration has been over. Therefore you cannot add
          more shipment. If you need more shipment, We suggest you create
          another shipment request (Contract) by clicking the Shipment button in
          the sidebar menu.
        </p>
        <p v-else>
          Opps... you have insufiicient contract value. Therefore you cannot add
          more shipment. If you need more shipment, We suggest you create
          another shipment request (Contract) by clicking the Shipment button in
          the sidebar menu.
        </p>
        <button
          @click="modalpress()"
          class="_global__button--corporite mt-3 pl-5 pr-5"
          style="height: 30px;"
        >
          OK
        </button>
      </div>
    </b-modal>

    <b-modal
      id="_instantprice__form2"
      ref="modalProcessInvoice"
      centered
      hide-footer
      title=""
    >
      <div class="">
        <p class="text-center">
          Your payment invoice has been made. You can later check your invoice
          in Payment > Waiting for Payment.
        </p>
      </div>
      <div class="row">
        <div class="col-md text-center mt-3">
          <b-button @click="modalpress()" class="_modals__button">OK</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="_business_agreement_"
      ref="modalBusinessAgreement"
      centered
      hide-footer
      title=""
    >
      <div>
        <p class="text-center">Business Agreement created</p>
        <div class="row m-0 d-flex justify-content-center">
          <button
            @click="modalpress()"
            class="_global__button--corporite pl-5 pr-5"
            style="height: 48px; width: 195.3px;"
          >
            OK
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Update Detail Shipment -->
    <b-modal
      ref="modalConfirmEditMS"
      id="modalConfirmEditMS"
      centered
      hide-footer
    >
      <div class="__body text-center">
        <div class="col-md justify-content-center">
          <img class="mb-3" src="@/assets/image/icon/warning-red.svg" alt="" />
        </div>
        <b>Are you sure want to move to another section? </b>
        <p class="my-3">
          Please click the save button first before leaving this page. Otherwise
          your progress will not be saved.
        </p>
        <div class="row justify-content-center">
          <button
            class="button__bluecorporite mr-3"
            @click="leavingEditSection()"
          >
            Yes
          </button>
          <button class="button__redcorporite" @click="continueEditSection()">
            No
          </button>
        </div>
      </div>
    </b-modal>
    <!-- END Update Detail Shipment -->
  </div>
</template>

<script>
import Booking from '@/components/instantPrice/Booking'
import mixinPrice from '@/mixin/getters/prices'
import mixinDetailShipment from '@/mixin/getters/shipment-details'
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'Modals',
  components: {
    Booking
  },
  mixins: [mixinPrice, mixinDetailShipment],
  data() {
    return {
      ipSelectedtabs: Booking,
      invite_alert_msg: '',
      invite_status: false,
      status: false,
      FCL: false,
      groupFreight: false,
      groupOLC: false,
      groupDLC: false,
      groupLC: false,
      groupReim: false,
      groupOthers: false,
      addRequestStatus: false,
      settingTypeValue: 'Document Type',
      settingOptionType: [
        { id: 1, text: 'NPWP', value: 'npwp' },
        { id: 2, text: 'NIB', value: 'nib' },
        { id: 3, text: 'SIUP', value: 'siup' },
        { id: 4, text: 'KTP', value: 'ktp' },
        { id: 5, text: 'Passport', value: 'passport' },
        { id: 6, text: 'License', value: 'license' },
        { id: 7, text: 'Other', value: 'others' }
      ],
      mgshipementTypeValue: 'Choose Your Request Type',
      mgshipementOptionType: [
        { id: 1, text: 'Maximum Temperature', value: 'min_temperature' },
        { id: 2, text: 'Minimum Temperature', value: 'max_temperature' },
        { id: 3, text: 'Carrier / Shipping Line', value: 'shipping_line' },
        { id: 4, text: 'Vessel', value: 'vessel' }
      ],
      mgshipementCategoryValue: 'File Category',
      requestCategoryValue: 'File Category',
      mgshipementCategory: [
        { text: 'API - Import License', value: 'API' },
        { text: 'AWB - Airway Bill', value: 'AWB' },
        { text: 'BL - Billing of Lading', value: 'BL' },
        { text: 'BL Draft - Bill of Lading Draft', value: 'BL_DRAFT' },
        { text: 'Certificate', value: 'CERTIFICATE' },
        { text: 'Goods Photo', value: 'PHOTO' },
        { text: 'HAWB - House Airway Bill', value: 'HAWB' },
        { text: 'HBL - House Bill of Lading', value: 'HBL' },
        { text: 'MAWB - Master Airway Bill', value: 'MAWB' },
        { text: 'MBL - Master of Bill Lading', value: 'MBL' },
        { text: 'Others', value: 'OTHERS' },
        { text: 'PEB - Pemberitahuan Ekspor Barang', value: 'PEB' },
        { text: 'PIB - Pemberitahuan Impor Barang', value: 'PIB' },
        { text: 'PL - Packing List', value: 'PL' }
      ],
      requestCategory: [
        { id: 1, text: 'Certificate', value: 'CERTIFICATE' },
        { id: 2, text: 'PL - Packing List', value: 'PL' },
        { id: 3, text: 'Goods Photo', value: 'PHOTO' },
        { id: 4, text: 'MSDS', value: 'MSDS' },
        { id: 5, text: 'Others', value: 'OTHERS' }
      ],
      typePrice: '',
      typeRfq: '',
      typeShipment: '',
      formDoc: {},
      formRequest: {
        id: '',
        type: '',
        number: '',
        requestExpired: ''
      },
      bookingData: {},
      addshipment_msg: '',
      totalPriceShipment: 0,
      isActive: false,
      isAvailable: false,
      errorFileCategory: '',
      idRfq: '',
      reqData: {},
      formReq: {},
      error_addshipment: '',
      weight_qty_ongoing: '',
      formAddShipment: {
        shipper_notes: '',
        po_number: ''
      },
      datePickup: '',
      queryAddShipment: {
        form: {
          datePickup: '',
          destinationCity: '',
          destinationCountry: '',
          originCity: '',
          originCountry: '',
          insuranceId: ''
        },
        shipmentLoad: ''
      },
      loadsAIR_LCL: {
        qty: '',
        size: {
          height: '',
          length: '',
          unit: 'cm',
          width: ''
        },
        type: '',
        weight: '',
        volume: '',
        weightUnit: 'kg'
      },
      loadsFCL: {
        qty: '',
        size: '',
        type: 'Container',
        weight: 0
      },
      start_duration: '',
      end_duration: '',
      satuan: 'Boxes',
      today: moment().format('YYYY-MM-DD'),
      remarksVendor: '',
      shipmentType: '',
      formShipmentReq: {
        requests: [],
        orderNumber: ''
      },
      inputShipmentReq: {},
      formSettingDocs: {
        uploadedBy: 'USER'
      },
      orderPrice: {},
      formUserInivite: {
        email: '',
        companyName: ''
      },
      statusShipment: '',
      upload_error: '',
      unitBid: '',
      unitName: '',
      idShipment: '',
      orderNo: '',
      remainingDays: '',
      estimateContractValue: '',
      totalUnit: 0,
      totalWeight: 0,
      totalVolume: 0,
      weightEstimation: 0,
      errorMessage: '',
      filename: 'Select Your File',
      colabText: '',
      messageResetPass: {
        code: '',
        message: ''
      },
      freightInfo: {
        mode: '',
        type: '',
        weightEstimation: 0
      }
    }
  },
  created() {
    this.$eventHub.$on('dialog-instantprice', this.dialogInstantPrice)
    this.$eventHub.$on('dialog-instantprice-form', this.dialogInstantPriceForm)
    this.$eventHub.$on('dialog-request-leave', this.dialogInstantPriceLeave)
    this.$eventHub.$on('dialog-details-promo', this.dialogDetailsPromo)
    this.$eventHub.$on('dialog-pricedetails', this.dialogPriceDetails)
    this.$eventHub.$on('dialog-help-submit', this.dialogHelpSubmit)
    this.$eventHub.$on('dialog-contract-pricing', this.dialogGoToRequestList)
    this.$eventHub.$on('dialog-setting-upload', this.dialogUploadFile)
    this.$eventHub.$on('dialog-setting-invite', this.dialogInvite)
    this.$eventHub.$on('dialog-setting-invite-hide', this.dialogInviteHide)
    this.$eventHub.$on('dialog-mgshipement-addrequest', this.dialogAddRequest)
    this.$eventHub.$on(
      'dialog-uploadpayment-proof',
      this.dialogUploadPaymentProof
    )
    this.$eventHub.$on('dialog-password-reset', this.dialogPasswordReset)
    this.$eventHub.$on('dialog-mgshipement-upload', this.dialogUploadDoc)
    this.$eventHub.$on('dialog-requestlist-form', this.dialogRequestListForm)
    this.$eventHub.$on('dialog-upload-attachment', this.dialogUploadAttachment)
    this.$eventHub.$on('dialog-rfq-tolist', this.dialogRFQlist)
    this.$eventHub.$on(
      'dialog-pricedetails-shipment',
      this.dialogPriceDetailsShipment
    )
    this.$eventHub.$on('dialog-forgot-password', this.dialogForgotPassword)
    this.$eventHub.$on(
      'dialog-collaborate-success',
      this.dialogCollaborateSuccess
    )
    this.$eventHub.$on(
      'dialog-mgshipement-upload-hide',
      this.dialogUploadDocHide
    )
    this.$eventHub.$on('dialog-add-shipment', this.dialogAddShipment)
    this.$eventHub.$on('dialog-cant-addshipment', this.dialogCantAddShipment)
    this.$eventHub.$on(
      'dialog-requestlist-contract-form',
      this.dialogRequestListContractForm
    )
    // this.$eventHub.$on('dialog-listcontract-extend', this.dialogBtnExtendContract)
    this.$eventHub.$on('dialog-process-invoice', this.dialogProcessInvoice)
    this.$eventHub.$on('dialog-business-agreement', this.dialogBA)
    this.$eventHub.$on('dialog-next-business-agreement', this.dialogNextBA)
    this.$eventHub.$on('dialog-confirm-edit-ms', this.dialogConfirmEditMS)
    this.$eventHub.$on('dialog-error-create-quotation', this.dialogErrorMessage)
    this.$eventHub.$on('dialog-request-cancel', this.dialogRequestCancel)
    this.$eventHub.$on('dialog-request-extend', this.dialogRequestExtend)
    this.$eventHub.$on('dialog-error-mceasy-rfq-land', this.dialogErrorMcEasy)
  },
  beforeDestroy() {
    this.$eventHub.$off('dialog-instantprice')
    this.$eventHub.$off('dialog-instantprice-form')
    this.$eventHub.$off('dialog-request-leave')
    this.$eventHub.$off('dialog-details-promo')
    this.$eventHub.$off('dialog-pricedetails')
    this.$eventHub.$off('dialog-help-submit')
    this.$eventHub.$off('dialog-contract-pricing')
    this.$eventHub.$off('dialog-setting-upload')
    this.$eventHub.$off('dialog-setting-invite')
    this.$eventHub.$off('dialog-mgshipement-addrequest')
    this.$eventHub.$off('dialog-uploadpayment-proof')
    this.$eventHub.$off('dialog-password-reset')
    this.$eventHub.$off('dialog-mgshipement-upload')
    this.$eventHub.$off('dialog-requestlist-form')
    this.$eventHub.$off('dialog-requestlist-cancel')
    this.$eventHub.$off('dialog-upload-attachment')
    this.$eventHub.$off('dialog-rfq-tolist')
    this.$eventHub.$off('dialog-pricedetails-shipment')
    this.$eventHub.$off('dialog-upload-attachment-req')
    this.$eventHub.$off('dialog-forgot-password')
    this.$eventHub.$off('dialog-mgshipement-upload-hide')
    this.$eventHub.$off('dialog-collaborate-success')
    this.$eventHub.$off('dialog-listrfq-cancel')
    this.$eventHub.$off('dialog-add-shipment')
    this.$eventHub.$off('dialog-requestlist-contract-form')
    this.$eventHub.$off('dialog-listcontract-extend')
    this.$eventHub.$off('dialog-process-invoice')
    this.$eventHub.$off('dialog-cant-addshipment')
    this.$eventHub.$off('dialog-business-agreement')
    this.$eventHub.$off('dialog-next-business-agreement')
    this.$eventHub.$off('dialog-confirm-edit-ms')
    this.$eventHub.$off('dialog-error-create-quotation')
    this.$eventHub.$off('dialog-request-cancel')
    this.$eventHub.$on('dialog-request-extend')
    this.$eventHub.$off('dialog-error-mceasy-rfq-land')
  },
  mounted: function() {
    if (this.isAuthenticated) {
      this.fetchUsers()
    }
  },
  methods: {
    closeModalCollabsSuccess() {
      this.$refs.modalCollabsSuccess.hide()
      this.$router.push('Login')
    },
    downloadPrice() {
      this.$store.dispatch('shipment/DOWNLOAD_PRICE_DETAIL', {
        shipmentId: this.idShipment,
        fileName: `Price_Detail_${this.orderNo}.pdf`
      })
    },
    dialogCantAddShipment(remainingDays, estimateContractValue) {
      this.remainingDays = remainingDays
      this.estimateContractValue = estimateContractValue
      this.$refs.modalCantAddShipment.show()
    },
    dialogProcessInvoice() {
      this.$refs.modalProcessInvoice.show()
    },
    modalpress: function(status) {
      this.$refs.modalIP.hide()
      this.$refs.modalIPform.hide()
      this.$refs.modalDetailsPromo.hide()
      this.$refs.modalHelpSubmit.hide()
      this.$refs.modalContact.hide()
      this.$refs.modalPasswordReset.hide()
      this.$refs.modalrequestform.hide()
      this.$refs.modaluploadDoc.hide()
      this.$refs.modalUploadAttachment.hide()
      this.$refs.modalForgotPassword.hide()
      this.$refs.modalPrevIP.hide()
      this.$refs.modalinviteuser.hide()
      this.$refs.modalRequestCancel.hide()
      this.$refs.modalrequestcontractform.hide()
      this.$refs.modalCantAddShipment.hide()
      this.$refs.modalBusinessAgreement.hide()
      this.$refs.modalErrorRFQContract.hide()
      this.$refs.modalErrorMcEasyRFQLand.hide()
    },
    dialogErrorMessage(message) {
      this.errorMessage = message
      this.$refs.modalErrorRFQContract.show()
    },
    dialogErrorMcEasy() {
      this.$refs.modalErrorMcEasyRFQLand.show()
    },
    dialogAddShipment(shipmentType, startDuration, endDuration) {
      this.end_duration = moment(endDuration).format('YYYY-MM-DD')
      this.start_duration = moment(startDuration).format('YYYY-MM-DD')
      this.shipmentType = shipmentType
      this.setEmptyAddShipment()
      this.weightEstimation = this.shipmentType.includes('FCL')
        ? this.contractItem.weight_estimation
        : 0
      this.totalWeight = this.weightEstimation
      this.satuan = this.contractItem.satuan
      this.loadsAIR_LCL.type = this.contractItem.satuan
      this.$refs.modalAddShipment.show()
    },
    async AddShipment() {
      if (
        (this.shipmentType === 'AIRCOURIER' || 'AIRCARGO' || 'SEALCL') &&
        ((this.loadsAIR_LCL.qty ||
          this.loadsAIR_LCL.weight ||
          this.loadsAIR_LCL.size.height ||
          this.loadsAIR_LCL.size.length ||
          this.loadsAIR_LCL.size.width) === '0' ||
          '' ||
          0)
      ) {
        this.error_addshipment = 'Should be more than 0!'
        this.status = false
      } else if (
        (this.shipmentType !== 'AIRCOURIER' || 'AIRCARGO' || 'SEALCL') &&
        parseInt(this.loadsFCL.qty) === 0
      ) {
        this.error_addshipment = 'Should be more than 0!'
        this.status = false
      } else {
        this.status = true
      }
      this.contract[0].shipper_notes = this.formAddShipment.shipper_notes
      if (this.status) {
        const form = Object.assign(
          this.contract[0],
          { book_price_currency_code: this.contract[0].price_currency_code },
          { goodsValue: this.contract[0].value_of_goods },
          { reference_number: this.contract[0].contract_number },
          { status_shipment: 2 },
          { shipment: this.contractItem.optiontp },
          { incoterms: this.contractItem.incoterms },
          { goodsValue: this.contract[0].value_of_goods },
          { po_number: this.formAddShipment.po_number },
          { originPortCode: this.contractItem.port_from || null },
          { originPortName: this.contractItem.portf || null },
          { destinationPortCode: this.contractItem.port_to || null },
          { destinationPortName: this.contractItem.portt || null },
          this.auth
        )
        const quote = Object.assign(
          this.contract[0],
          { bidId: this.bidList[0].id },
          { carrier_name: this.bidList[0].shippingline },
          { reference_number: this.contract[0].contract_number },
          { goodsValue: this.contract[0].value_of_goods },
          { hsCode: this.contract[0].commodities_hscode },
          {
            weight_estimation: this.shipmentType.includes('FCL')
              ? parseInt(this.weightEstimation, 0)
              : this.contractItem.weight_estimation
          },
          { un_number: this.contractItem.un_number },
          { container_option: this.contractItem.container_option },
          { status_shipment: 2 },
          { rfqStatus: false },
          { orderPriceInsurance: [] },
          {
            satuan: this.shipmentType.includes('FCL')
              ? this.loadsFCL.type
              : this.loadsAIR_LCL.type
          },
          {
            dimension: JSON.stringify({
              height: this.loadsAIR_LCL.size.height,
              length: this.loadsAIR_LCL.size.length,
              width: this.loadsAIR_LCL.size.width
            })
          },
          { statusBid: this.bidList[0].status_bid }
        )

        const dimension =
          parseInt(this.loadsAIR_LCL.size.length) *
          parseInt(this.loadsAIR_LCL.size.width) *
          parseInt(this.loadsAIR_LCL.size.height)
        if (this.shipmentType === 'AIRCARGO') {
          this.loadsAIR_LCL.volume = Math.ceil(dimension / 6000)
        } else if (this.shipmentType === 'AIRCOURIER') {
          this.loadsAIR_LCL.volume = Math.ceil(dimension / 5000)
        } else {
          this.loadsAIR_LCL.volume = Math.ceil(dimension / 1000000)
        }
        var airCargo = []
        airCargo.push(this.loadsAIR_LCL)
        var airCourier = []
        airCourier.push(this.loadsAIR_LCL)
        var fcl = []
        fcl.push(this.loadsFCL)
        var lcl = []
        lcl.push(this.loadsAIR_LCL)
        this.queryAddShipment.form.datePickup = this.getDate2(this.datePickup)
        this.queryAddShipment.form.destinationCity = this.contract[0].destination_city_code
        this.queryAddShipment.form.destinationCountry = this.contract[0].destination_country_code
        this.queryAddShipment.form.originCity = this.contract[0].origin_city_code
        this.queryAddShipment.form.originCountry = this.contract[0].origin_country_code
        this.queryAddShipment.shipmentLoad = this.contract[0].freight_type
        this.queryAddShipment.form.insuranceId = this.contract[0].id_insurance
        this.queryAddShipment.form.customsClearanceOrigin =
          this.contractItem.option_customs_clearance === 'true' ? 1 : 0
        this.queryAddShipment.form.customsClearanceDestination =
          this.contractItem.option_customs_clearance_destination === 'true'
            ? 1
            : 0
        this.queryAddShipment.form.estimateStorage =
          this.contractItem.option_estimate_storage === 'true' ? 1 : 0
        this.queryAddShipment.form.customsInsurace = 1
        this.queryAddShipment.form = Object.assign(
          this.queryAddShipment.form,
          { loadsAIRCargo: airCargo },
          { loadsAIRCourier: airCourier },
          { loadsFCL: fcl },
          { loadsLCL: lcl }
        )
        const payload = Object.assign(
          { form },
          { quote },
          { query: this.queryAddShipment }
        )
        await this.$store.dispatch('book/POST_BOOK_ORDER', payload)
        if (!this.isErrorBook) {
          this.addshipment_msg = 'Successfully added!'
          const id = this.$route.params.id_contract
          await this.$store.dispatch('contract/GET_CONTRACT_DETAIL', id)
          await this.$store.dispatch('contract/GET_SHIPMENT_ONGOING', id)
          this.addshipment_msg = ''
          this.emptyLoad()
          this.$refs.modalAddShipment.hide()
        } else {
          this.addshipment_msg = this.isErrorBook.data.message
          setTimeout(() => {
            this.addshipment_msg = ''
            this.emptyLoad()
          }, 3000)
        }
      }
    },
    emptyLoad() {
      this.loadsAIR_LCL.qty = ''
      this.loadsAIR_LCL.weight = ''
      this.loadsAIR_LCL.size.height = ''
      this.loadsAIR_LCL.size.length = ''
      this.loadsAIR_LCL.size.width = ''
      this.loadsFCL.qty = ''
      this.loadsFCL.size = ''
      this.formAddShipment.shipper_notes = ''
      this.formAddShipment.po_number = ''
      this.datePickup = ''
      this.queryAddShipment.form.datePickup = ''
    },
    setQtyType(type) {
      this.satuan = type
      this.loadsAIR_LCL.type = type
    },
    deleteErrorMsg() {
      this.error_addshipment = ''
    },
    dialogRequestExtend(idRequest, numberRequest, typeRequest) {
      this.formRequest.id = idRequest
      this.formRequest.number = numberRequest
      this.formRequest.type = typeRequest
      this.$refs.modalRequestExtend.show()
    },
    dialogRequestCancel(idRequest, typeRequest) {
      this.formRequest.id = idRequest
      this.formRequest.type = typeRequest
      this.$refs.modalRequestCancel.show()
    },
    async fetchRequestList() {
      const currentPage = 1
      const perPage = 10
      if (this.formRequest.type === 'RFQ') {
        await this.$store.dispatch('rfq/FETCH_RFQ', {
          type: 'ongoing',
          currentPage,
          perPage
        })
      } else if (this.formRequest.type === 'Contract') {
        await this.$store.dispatch('contract/FETCH_CONTRACT', {
          type: 'ongoing',
          currentPage,
          perPage
        })
      }
    },
    async deleteListRequest() {
      if (this.formRequest.type === 'RFQ') {
        await this.$store.dispatch('rfq/CANCEL_RFQ', {
          id: this.formRequest.id
        })
        this.fetchRequestList()
        this.modalpress()
      } else if (this.formRequest.type === 'Contract') {
        await this.$store.dispatch('contract/CANCEL_CONTRACT', {
          id: this.formRequest.id
        })
        this.fetchRequestList()
        this.modalpress()
      }
    },
    async handleExtendRequest() {
      if (this.formRequest.type === 'RFQ') {
        const payload = {
          rfqId: this.formRequest.id,
          rfqNumber: this.formRequest.number,
          requestExpired: this.formRequest.requestExpired
        }
        await this.$store.dispatch('rfq/EXTEND_RFQ', payload)
      } else if (this.formRequest.type === 'Contract') {
        const payload = {
          contractId: this.formRequest.id,
          contractNumber: this.formRequest.number,
          requestExpired: this.formRequest.requestExpired
        }
        await this.$store.dispatch('contract/EXTEND_CONTRACT', payload)
      }
    },
    resetModalFormRequest: function() {
      this.formRequest = {
        id: '',
        type: '',
        number: '',
        requestExpired: ''
      }
    },
    dialogGoToPayment: function(status) {
      this.$refs.modalIPform2.hide()
    },
    dialogGoToRFQlist: function(status) {
      this.$refs.modalRFQ.hide()
    },
    dialogConfirmEditMS() {
      this.$refs.modalConfirmEditMS.show()
    },
    leavingEditSection() {
      this.$eventHub.$emit('catch-confrim-edit-MS', true)
      this.$refs.modalConfirmEditMS.hide()
    },
    continueEditSection() {
      this.$eventHub.$emit('catch-confrim-edit-MS', false)
      this.$refs.modalConfirmEditMS.hide()
    },
    dialogRequest: function(status) {
      this.$refs.modalrequestform2.hide()
    },
    dialogInstantPrice() {
      this.$refs.modalIP.show()
    },
    dialogInstantPriceForm(data) {
      this.bookingData = data
      this.$refs.modalIPform.show()
    },
    dialogInstantPriceLeave() {
      this.$refs.modalPrevIP.show()
    },
    dialogRequestListForm(type) {
      this.shipmentType = type
      this.$refs.modalrequestform.show()
    },
    dialogRequestListContractForm() {
      this.$refs.modalrequestcontractform.show()
    },
    dialogDetailsPromo() {
      this.$refs.modalDetailsPromo.show()
    },
    dialogPriceDetails(item) {
      this.orderPrice = item
      this.$refs.modalPriceDetails.show()
    },
    dialogHelpSubmit() {
      this.$refs.modalHelpSubmit.show()
    },
    dialogGoToRequestList() {
      this.$refs.modalContact.show()
    },
    dialogForgotPassword() {
      this.$refs.modalForgotPassword.show()
    },
    dialogCollaborateSuccess(text) {
      this.colabText = text
      this.$refs.modalCollabsSuccess.show()
    },
    dialogUploadFile() {
      this.$refs.modalUpload.show()
    },
    dialogInvite({ compName }) {
      this.formUserInivite.companyName = compName
      this.$refs.modalinviteuser.show()
    },
    dialogAddRequest(data) {
      this.formShipmentReq.shipmentId = data.shipmentId
      this.formShipmentReq.orderNumber = data.orderNumber
      this.formShipmentReq.vendorId = data.vendorId
      this.$refs.modaladdRequest.show()
    },
    dialogRFQlist() {
      this.$refs.modalRFQ.show()
      setTimeout(() => {
        this.$refs.modalRFQ.hide()
        this.$router.push('/request-list/rfq').then(() => {})
      }, 2000)
    },
    dialogUploadDoc({ id, referenceNumber, type }) {
      this.formDoc.shipmentId = id
      this.formDoc.orderNumber = referenceNumber
      this.formDoc.type = type
      this.$refs.modaluploadDoc.show()
    },
    dialogUploadDocHide() {
      this.$refs.modaluploadDoc.hide()
    },
    selectedOption: function(event, type) {
      if (type === 'type') {
        this.formSettingDocs.documentType = event
        this.settingTypeValue = event
      } else if (type === 'mg-type') {
        this.mgshipementTypeValue = event
        if (event === this.mgshipementOptionType[2].text) {
          this.addRequestStatus = true
        } else {
          this.addRequestStatus = false
        }
      } else if (type === 'mg-category') {
        this.mgshipementCategoryValue = event
        this.formDoc.documentCategory = event
        this.errorFileCategory = ''
      } else if (type === 'req-category') {
        this.requestCategoryValue = event
        this.formReq.documentCategory = event
        this.errorFileCategory = ''
      }
    },
    dialogUploadPaymentProof() {
      this.$refs.modalPaymentProof.show()
    },
    dialogPasswordReset(data) {
      this.$refs.modalPasswordReset.show()
      this.messageResetPass.message = data.message || ''
      this.messageResetPass.code = data.code || ''
    },
    modalpressResetPwd() {
      this.$router.push({ name: 'Signin' })
      this.$refs.modalPasswordReset.hide()
    },
    dialogPriceDetailsShipment({
      typeShipment,
      remarks,
      statusShipment,
      shipmentId,
      orderNumber
    }) {
      this.remarksVendor = remarks
      this.typeShipment = typeShipment
      this.statusShipment = statusShipment
      this.idShipment = shipmentId
      this.orderNo = orderNumber
      this.$refs.modalPriceDetailsShipment.show()
    },
    async placeOrder() {
      this.$refs.modalrequestform.hide()
      await this.$store.dispatch('book/POST_BOOK_ORDER', this.book).then(() => {
        this.$refs.modalrequestform2.show()
      })
    },
    async placeOrderContract() {
      this.$refs.modalrequestcontractform.hide()
      await this.$store
        .dispatch('book/POST_BOOK_CONTRACT', this.book)
        .then(() => {
          this.$refs.modalrequestform2.show()
        })
    },
    async placeOrderIP() {
      this.$refs.modalIPform.hide()
      await this.$store
        .dispatch('book/POST_BOOK_ORDER', this.bookingData)
        .then(() => {
          this.$refs.modalIPform2.show()
        })
    },
    dialogUploadAttachment({ id, referenceNumber, type }) {
      if (type === 'RFQ') {
        this.formReq.rfqId = id
        this.formReq.rfqNumber = referenceNumber
      } else if (type === 'CONTRACT') {
        this.formReq.contractId = id
        this.formReq.contractNumber = referenceNumber
      } else if (type === 'INSTANT-REQUEST') {
        this.formReq.rfqId = id
        this.formReq.rfqNumber = referenceNumber
      }
      this.formReq.type = type
      this.filename = 'Select Your File'
      this.$refs.modalUploadAttachment.show()
    },
    handleUploadDoc() {
      this.$validator.validateAll().then(result => {
        this.chkInputFile()
        if (result && this.isActive) {
          let formData = new FormData()
          formData.append('shipmentId', this.formDoc.shipmentId)
          formData.append('orderNumber', this.formDoc.orderNumber)
          formData.append('documentCategory', this.formDoc.documentDesc) // nama file custom dari user
          formData.append('documentOrigin', 'WEBAPP')
          formData.append('documentDesc', this.formDoc.documentCategory) // category di pindah/simpan ke deskripsi)
          formData.append('fileDocument', this.formDoc.fileDocument)
          formData.append('type', this.formDoc.type)

          if (this.formDoc.fileDocument.size > 5000000) {
            this.upload_error = 'Your file exceeded maximum requirement file'
            setTimeout(() => {
              this.upload_error = ''
            }, 3000)
          } else {
            this.$store.dispatch('file/UPLOAD_DOCUMENT', formData)
          }
        }
      })
    },
    getDate(date) {
      return moment(date).format('DD MMMM YYYY')
    },
    getDate2(date) {
      return moment(date).format('DD/MM/YY')
    },
    getDate3(date) {
      return moment(date).format('DD MMM YYYY')
    },
    getDay(date) {
      return moment(date).format('DD')
    },
    chkInputFile() {
      if (
        this.formDoc.documentCategory &&
        this.formDoc.documentDesc &&
        this.formDoc.fileDocument
      ) {
        this.formDoc.documentDesc = this.replaceSpecialCharacter(
          this.formDoc.documentDesc
        )
        this.isActive = true
        this.errorFileCategory = ''
      } else if (!this.formDoc.documentCategory) {
        this.errorFileCategory = 'The file category field is required'
      } else {
        this.isActive = false
      }
    },
    replaceSpecialCharacter(fileName) {
      return fileName.replace(/[/\\?%*:|"<>]/g, '')
    },
    handleUploadDocReq() {
      this.$validator.validateAll().then(result => {
        this.chkInputFileReq()
        if (result && this.isActive) {
          let formData = new FormData()
          if (
            this.formReq.type === 'RFQ' ||
            this.formReq.type === 'INSTANT-REQUEST'
          ) {
            formData.append('rfqId', this.formReq.rfqId)
            formData.append('rfqNumber', this.formReq.rfqNumber)
          } else if (this.formReq.type === 'CONTRACT') {
            formData.append('contractId', this.formReq.contractId)
            formData.append('contractNumber', this.formReq.contractNumber)
          }
          formData.append('documentCategory', this.formReq.documentDesc) // nama file custom dari userdocumentCategory)
          formData.append('documentOrigin', 'WEBAPP')
          formData.append('documentDesc', this.formReq.documentCategory) // category di pindah/simpan ke deskripsi)
          formData.append('fileDocument', this.formReq.fileDocument)
          formData.append('type', this.formReq.type)
          if (this.formReq.fileDocument.size > 5000000) {
            this.upload_error = 'Your file exceeded maximum requirement file'
            setTimeout(() => {
              this.upload_error = ''
            }, 2000)
          } else {
            this.$store.dispatch('file/UPLOAD_DOCUMENT', formData).then(() => {
              if (this.isUploaded && this.formReq.type === 'INSTANT-REQUEST') {
                this.$store.dispatch(
                  'instantQuote/FETCH_IQ_BY_ID',
                  this.formReq.rfqId
                )
              }
            })
          }
        }
      })
    },
    chkInputFileReq() {
      if (
        this.formReq.documentCategory &&
        this.formReq.documentDesc &&
        this.formReq.fileDocument
      ) {
        this.formReq.documentDesc = this.replaceSpecialCharacter(
          this.formReq.documentDesc
        )
        this.isActive = true
      } else if (!this.formReq.documentCategory) {
        this.errorFileCategory = 'The file category field is required'
      } else {
        this.isActive = false
      }
    },
    addRequest() {
      let arr = this.formShipmentReq.requests

      // this.inputShipmentReq.id = 0
      // this.inputShipmentReq.value = this.inputShipmentReq.value
      // this.inputShipmentReq.note = this.inputShipmentReq.note
      const test = {
        requestId: 0,
        type: 'min_temperature',
        value: '1',
        note: 'test'
      }
      arr.push(test)
    },
    getOptionTp(type) {
      let optionTp = '-'
      switch (type) {
        case 'PTP':
          optionTp = 'Port to Port'
          break
        case 'DTP':
          optionTp = 'Door to Port'
          break
        case 'DTD':
          optionTp = 'Door to Door'
          break
        case 'PTD':
          optionTp = 'Port to Door'
          break
        default:
          optionTp = '-'
      }
      return optionTp
    },
    // SETTING DOC UPLOAD
    handleUploadSettingDocs() {
      let formData = new FormData()
      formData.append('uploadedBy', this.formSettingDocs.uploadedBy)
      formData.append('documentType', this.formSettingDocs.documentType)
      formData.append('fileDocument', this.formSettingDocs.fileDocument)

      if (this.$refs.fileSettingDoc.files[0].size > 5000000) {
        this.upload_error = 'Your file exceeded maximum requirement file'
        setTimeout(() => {
          this.upload_error = ''
        }, 3000)
      } else {
        this.$store.dispatch('settingDocs/UPLOAD_DOCS', formData)
      }
    },
    // SETTING INVITE USERS
    async handleInviteUser() {
      const payload = {
        userEmail: this.formUserInivite.email,
        companyName: this.formUserInivite.companyName
      }
      await this.inviteUser(payload)
      this.fetchUsers()
      // this.ifInvited('Successfully inviting user!', true)
    },
    inviteUser(payload) {
      this.$store.dispatch('settingUsers/POST_INVITE', payload)
    },
    fetchUsers() {
      this.$store.dispatch('settingUsers/FETCH_USERS')
    },
    ifInvited(text, type) {
      this.invite_alert_msg = text
      this.invite_status = type
      setTimeout(() => {
        this.invite_alert_msg = ''
      }, 2000)
      this.isAvailable = false
    },
    checkUsersInvited(text) {
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].username === text) {
          this.isAvailable = true
        }
      }
      if (this.isAvailable) {
        return this.ifInvited('Sorry, user has been invited!', false)
      } else {
        return this.handleInviteUser()
      }
    },
    /// ////////////////
    chkInputFileSetting() {
      if (
        this.formSettingDocs.documentType &&
        this.formSettingDocs.fileDocument
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    handleFileSettingUpload() {
      this.formSettingDocs.fileDocument = this.$refs.fileSettingDoc.files[0]
      if (
        this.formSettingDocs.documentType &&
        this.formSettingDocs.fileDocument
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    // END SETTING DOC UPLOAD
    thousandSeparator(price) {
      let tempPrice = 0
      if (price <= 0) {
        tempPrice = price
      } else {
        tempPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return tempPrice
    },
    // formula
    getUOM(uom) {
      let uomPrice = 'ALL'
      switch (uom) {
        case 'VW CBM':
          uomPrice = 'Per CBM'
          break
        case 'VW KG':
          uomPrice = 'Per KG'
          break
        case 'CONT':
          uomPrice = 'Per Container'
          break
        case 'ALL DOC':
          uomPrice = 'Per Document'
          break
        case 'ALL ITEM':
          uomPrice = 'Per Item'
          break
        case 'ALL SHIPMENT':
          uomPrice = 'Per Shipment'
          break
        case 'CONT FCL':
          uomPrice = 'Per Trip (FCL)'
          break
        case 'ALL TRIP':
          uomPrice = 'Per Trip (LCL)'
          break
        case 'AIR TRIP':
          uomPrice = 'Per Trip (Air)'
          break
        case 'ALL BOX':
          uomPrice = 'Per Box'
          break
        case 'ALL BL':
          uomPrice = 'Per BL'
          break
        case 'ALL':
          uomPrice = 'Per Item'
          break
        case 'VW':
          uomPrice = 'VW'
          break
        case 'WEIGHT':
          uomPrice = 'WEIGHT'
          break
        case 'VOL':
          uomPrice = 'VOL'
          break
        case 'LCL TRIP':
          uomPrice = 'Per Trip (LCL)'
          break
        case 'FCL TRIP':
          uomPrice = 'Per Trip (FCL)'
          break
        case 'CW':
          uomPrice = 'Per CW'
          break
        case 'ALL M3':
          uomPrice = 'Per M3'
          break
        case 'ALL MT':
          uomPrice = 'Per MT'
          break
        default:
          uomPrice = 'ALL'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return uomPrice
      /* eslint-disable-next-line */
    },
    dialogBA() {
      this.$refs.modalBusinessAgreement.show()
    },
    dialogNextBA() {
      this.$refs.modalrequestform2.show()
    },
    goBack() {
      this.$router.go(-1)
      localStorage.removeItem('bookingFormData')
      localStorage.removeItem('instantPriceData')
      this.modalpress()
    },
    calcTotalShipment() {
      if (
        this.shipmentType === 'AIRCARGO' ||
        this.shipmentType === 'AIRCOURIER' ||
        this.shipmentType === 'SEALCL'
      ) {
        let volume = 0
        const quantity = this.loadsAIR_LCL.qty
        const weight = !_.isEmpty(this.loadsAIR_LCL.weight)
          ? this.loadsAIR_LCL.weight
          : 0
        const length = !_.isEmpty(this.loadsAIR_LCL.size.length)
          ? parseInt(this.loadsAIR_LCL.size.length)
          : 0
        const width = !_.isEmpty(this.loadsAIR_LCL.size.width)
          ? parseInt(this.loadsAIR_LCL.size.width)
          : 0
        const height = !_.isEmpty(this.loadsAIR_LCL.size.height)
          ? parseInt(this.loadsAIR_LCL.size.height)
          : 0
        const dimension =
          parseInt(length, 10) * parseInt(width, 10) * parseInt(height, 10)
        if (this.shipmentType === 'AIRCARGO') {
          volume = (dimension * quantity) / 6000
        } else if (this.shipmentType === 'AIRCOURIER') {
          volume = (dimension * quantity) / 5000
        } else {
          volume = dimension / 1000000
        }
        this.totalUnit = !_.isEmpty(quantity) ? quantity : 0
        const totalWeight = quantity * weight
        this.totalVolume =
          this.shipmentType === 'SEALCL'
            ? volume.toFixed(2)
            : parseFloat(this.roundToHalf(volume)).toFixed(1)
        this.totalWeight =
          this.shipmentType === 'AIRCOURIER'
            ? parseFloat(this.roundToHalf(totalWeight)).toFixed(1)
            : this.shipmentType === 'SEALCL'
            ? totalWeight.toFixed(1)
            : Math.ceil(totalWeight)
      } else {
        this.totalUnit = !_.isEmpty(this.loadsFCL.qty) ? this.loadsFCL.qty : 0
        this.totalWeight =
          this.weightEstimation !== '' ? this.weightEstimation : 0
      }
    },
    setEmptyAddShipment() {
      this.totalUnit = 0
      this.totalWeight = 0
      this.totalVolume = 0
      this.weightEstimation = 0
      this.datePickup = ''
      this.loadsAIR_LCL.qty = ''
      // this.satuan = 'Boxes'
      this.loadsFCL.qty = ''
      this.loadsAIR_LCL.weight = ''
      this.loadsAIR_LCL.size.length = ''
      this.loadsAIR_LCL.size.width = ''
      this.loadsAIR_LCL.size.height = ''
      this.formAddShipment.po_number = ''
      this.formAddShipment.shipper_notes = ''
    },
    roundToHalf(value) {
      const converted = parseFloat(value) // Make sure we have a number
      let decimal = converted - parseInt(converted, 10)
      decimal = Math.round(decimal * 10)
      if (decimal === 5) {
        return parseInt(converted, 10) + 0.5
      }
      if (decimal < 1 || decimal > 5) {
        return Math.round(converted)
      }
      return parseInt(converted, 10) + 0.5
    },

    resetModalUploadDoc(type) {
      if (type === 'SHIPMENT') {
        this.mgshipementCategoryValue = 'File Category'
        this.formDoc = {
          shipmentId: '',
          orderNumber: '',
          documentCategory: null,
          documentDesc: '',
          fileDocument: null,
          type: ''
        }
      } else if (type === 'SETTING') {
        this.settingTypeValue = 'Document Type'
        this.formSettingDocs = {
          uploadedBy: 'USER',
          documentType: '',
          fileDocument: null
        }
      } else if (type === 'REQUEST') {
        this.requestCategoryValue = 'File Category'
        this.formReq = {
          rfqId: null,
          rfqNumber: '',
          contractId: null,
          contractNumber: '',
          documentCategory: null,
          documentDesc: '',
          fileDocument: null,
          type: ''
        }
      }
    },

    chooseGroupComponent(priceGroupCode) {
      let group = ''
      if (
        priceGroupCode === 'FRE' ||
        priceGroupCode === 'PTP' ||
        priceGroupCode === 'FREIGHT' ||
        priceGroupCode === 'FCL' ||
        priceGroupCode === 'LCL' ||
        priceGroupCode === 'LCT' ||
        priceGroupCode === 'BARGE' ||
        priceGroupCode === 'AIR'
      ) {
        group = 'FREIGHT'
      } else if (
        priceGroupCode === 'LC' ||
        priceGroupCode === 'LOCALCHARGES' ||
        priceGroupCode === 'LCORIGIN' ||
        priceGroupCode === 'OTC' ||
        priceGroupCode === 'OTC' ||
        priceGroupCode === 'OCC' ||
        priceGroupCode === 'OLC' ||
        priceGroupCode === 'ODG' ||
        priceGroupCode === 'TCK' ||
        priceGroupCode === 'TRC' ||
        priceGroupCode === 'LCDESTINATION' ||
        priceGroupCode === 'DLC' ||
        priceGroupCode === 'DCC' ||
        priceGroupCode === 'DTC' ||
        priceGroupCode === 'DDG'
      ) {
        group = 'LC'
      } else if (
        priceGroupCode === 'OTHERS' ||
        priceGroupCode === 'OVERTIME' ||
        priceGroupCode === 'ADJ' ||
        priceGroupCode === 'REI'
      ) {
        group = 'OVERTIME'
      } else if (priceGroupCode === 'REIMBURSEMENT') {
        group = 'REIMBURSEMENT'
      }
      return group
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuth',
      profile: 'auth/profile',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      book: 'book/forms',
      booked: 'book/items',
      isLoadingBook: 'book/isLoading',
      isErrorBook: 'book/error',
      bidDataDetail: 'book/dataTemp',
      // bid price rfq
      bidPriceRfq: 'rfq/bidPrice',
      isLoadingBidPriceRfq: 'rfq/isLoadingBidPrice',
      isErrorLoadingBidPriceRfq: 'rfq/isErrorLoadingBidPrice',
      // bid price contract
      bidPriceContract: 'contract/bidPrice',
      isLoadingBidPriceContract: 'contract/isLoadingBidPrice',
      isErrorLoadingBidPriceContract: 'contract/isErrorLoadingBidPrice',
      // upload file
      isUploading: 'file/isUploading',
      isErrorUploading: 'file/errorUploading',
      isUploaded: 'file/isUploaded',
      errorUploading: 'file/errorUploading',
      // setting user
      invited: 'settingUsers/invited',
      isErrorInvited: 'settingUsers/isErrorInvited',
      isLoadingInvited: 'settingUsers/isLoadingInvited',
      // extend rfq
      isLoadingExtend: 'rfq/isLoadingExtend',
      isErrorExtend: 'rfq/errorExtend',
      itemExtend: 'rfq/itemExtend',
      // create rfq
      createdRfq: 'rfq/created',
      createdRfqError: 'rfq/error',
      createdRfqIsLoading: 'rfq/isLoadingCreated',
      // create contract
      createdContract: 'contract/obj',
      createdContractError: 'contract/error',
      createdContractIsLoading: 'contract/isLoading',
      // shipment price
      priceList: 'shipment/prices',
      isLoadingPrice: 'shipment/isLoadingPrice',
      isErrorPrice: 'shipment/errorPrice',
      // promo details
      promoDetails: 'promo/promoDetails',
      isLoadingPromoDetails: 'promo/isLoadingPromoDetails',
      isErrorPromoDetails: 'promo/errorPromoDetails',
      // uploading doc setting
      errorUploadingSetting: 'settingDocs/errorUploading',
      isUploadingSetting: 'settingDocs/isUploading',
      docSetting: 'settingDocs/doc',
      // users
      users: 'settingUsers/users',
      errorUsers: 'settingUsers/error',
      isLoadingUsers: 'settingUsers/isLoading',
      // auth
      auth: 'auth/profile',
      authError: 'auth/error',
      authIsLoading: 'auth/isLoading',

      // contract
      contract: 'contract/details',
      contractItem: 'contract/item',
      isLoadingContract: 'contract/isLoadingDetails',
      isErrorContract: 'contract/isErrorDetails',
      // bid
      bidList: 'contract/bids',
      isLoadingBidList: 'contract/isLoading',
      // extend contract
      isLoadingExtendContract: 'contract/isLoadingExtend',
      isErrorExtendContract: 'contract/errorExtend',
      itemExtendContract: 'contract/itemExtend',

      // RFQ details
      rfqData: 'rfq/item',

      // download price detail
      downloadPriceDetail: 'shipment/downloadPriceDetail',
      errorDownloadPriceDetail: 'shipment/errorDownloadPriceDetail',
      isLoadingDownloadPriceDetail: 'shipment/isLoadingDownloadPriceDetail',

      detail: 'shipment/item'
    })
  },
  watch: {
    detail(data) {
      if (data) {
        this.freightInfo.mode = data.freightMode
        this.freightInfo.type = data.freightType
        this.freightInfo.weightEstimation = data.weight_estimation
      }
    },

    isErrorInvited(data) {
      if (data) {
        this.ifInvited(data.message, false)
      }
    },
    invited(data) {
      if (data) {
        this.ifInvited('Successfully inviting user!', true)
      }
    },
    itemExtend(newValue, oldValue) {
      if (newValue && !this.isErrorExtend) {
        this.fetchRequestList()
        this.$refs.modalRequestExtend.hide()
      }
    },
    itemExtendContract(newValue, oldValue) {
      if (newValue && !this.isErrorExtendContract) {
        this.fetchRequestList()
        this.$refs.modalRequestExtend.hide()
      }
    },
    priceList(data, oldData) {
      let i = 0
      let _totalPrice = 0
      if (data) {
        this.groupFreight = false
        this.groupLC = false
        this.groupReim = false
        this.groupOthers = false
        for (i; i < data.length; i++) {
          _totalPrice += parseFloat(
            parseInt(data[i].bookPriceSum * 100, 10) / 100,
            2
          )
          // conditioning show hide group price
          if (
            data[i].priceGroupCode === 'FRE' ||
            data[i].priceGroupCode === 'PTP' ||
            data[i].priceGroupCode === 'FREIGHT' ||
            data[i].priceGroupCode === 'FCL' ||
            data[i].priceGroupCode === 'LCL' ||
            data[i].priceGroupCode === 'LCT' ||
            data[i].priceGroupCode === 'BARGE' ||
            data[i].priceGroupCode === 'AIR'
          ) {
            this.groupFreight = true
          }
          if (
            data[i].priceGroupCode === 'LC' ||
            data[i].priceGroupCode === 'LOCALCHARGES' ||
            data[i].priceGroupCode === 'LCORIGIN' ||
            data[i].priceGroupCode === 'OTC' ||
            data[i].priceGroupCode === 'OTC' ||
            data[i].priceGroupCode === 'OCC' ||
            data[i].priceGroupCode === 'OLC' ||
            data[i].priceGroupCode === 'ODG' ||
            data[i].priceGroupCode === 'TCK' ||
            data[i].priceGroupCode === 'TRC' ||
            data[i].priceGroupCode === 'LCDESTINATION' ||
            data[i].priceGroupCode === 'DLC' ||
            data[i].priceGroupCode === 'DCC' ||
            data[i].priceGroupCode === 'DTC' ||
            data[i].priceGroupCode === 'DDG'
          ) {
            this.groupLC = true
          }
          if (
            data[i].priceGroupCode === 'OTHERS' ||
            data[i].priceGroupCode === 'OVERTIME' ||
            data[i].priceGroupCode === 'ADJ' ||
            data[i].priceGroupCode === 'REI'
          ) {
            this.groupOthers = true
          }
          if (data[i].priceGroupCode === 'REIMBURSEMENT') {
            this.groupReim = true
          }
        }
      }
      this.totalPriceShipment = _totalPrice
    },
    docSetting(newValue, oldValue) {
      // if (newValue !== oldValue && !this.errorUploadingSetting) {
      this.$store.dispatch('settingDocs/FETCH_DOCS')
      this.$refs.modalUpload.hide()
      // }
    },
    isUploaded(value) {
      if (value) {
        this.$refs.modalUploadAttachment.hide()
        this.$refs.modaluploadDoc.hide()
        this.formDoc.documentDesc = ''
        const input = this.$refs.fileDocument
        input.type = 'text'
        input.type = 'file'
      }
    },
    booked(data) {
      if (data) {
        const payloadLog = {
          featureName: 'CREATE INSTANT PRICE',
          featureStep: 8,
          stepName: 'Place Order',
          featureProcess: {
            status: 'success',
            data
          }
        }
        // insert log
        this.$store.dispatch('log/CREATE_LOG', payloadLog)
      }
    },
    isErrorBook(data) {
      if (data) {
        const payloadLog = {
          featureName: 'CREATE INSTANT PRICE',
          featureStep: 8,
          stepName: 'Place Order',
          featureProcess: {
            status: 'failed',
            data
          }
        }
        // insert log
        this.$store.dispatch('log/CREATE_LOG', payloadLog)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/Random.vue